import Jax from '@bxs/jax'
import { IS_PRODUCT_ENV, IS_APP_PLATFORM, BXS_APPID, BROKER_APPID, WX_AUTH_PUBLIC_APPID, getAppId } from 'common/utils/variables'
import { getUrlParam } from 'common/js/common'
import { PLANBOOK_PAGE_MAP } from '@/config/assets'

// 浏览器刷新
export const BROWSER_TIME = 20
// 动画
export const ANIMATION_TIME = 500
// 封面关闭时间
export const COVER_TIME = 5000
export const COMPS_SLIDING_PERCENTAGE = 0.9
export const DEFAULT_BANNER = {
  healthy: '//img.winbaoxian.com/autoUpload/planbook/__3903b52c73239a1.jpg',
  accident: '//img.winbaoxian.com/autoUpload/planbook/-_61eb22f84d4aff1.jpg',
  financing: '//img.winbaoxian.com/autoUpload/planbook/-4_40f2f87b74ee2b9.jpg',
  financing2: '//img.winbaoxian.com/autoUpload/planbook/-1_0348a7798715dc5.jpg',
  financing3: '//img.winbaoxian.com/autoUpload/planbook/-2_08ab30c805ee555.jpg',
  diff: '//img.winbaoxian.com/autoUpload/planbook/-3_c4d59a6b1492ef2.jpg',
  children:
    '//img.winbaoxian.com/autoUpload/planbook/21051567133793_.pic_hd_e7a6f439f27f756.jpg'
}

// 险种分类顺序
// 身价保障1 固定领取2 疾病保障3
// 浮动分红4 医疗保障5 保费豁免6
// 万能账户7 伤残保障8 其他保障9
export const insTypeIcon = [
  'approve',
  'money',
  'health',
  'develop',
  'medical',
  'free',
  'settlement',
  'disability',
  'more_point'
]
insTypeIcon[51] = 'lifetime_line'
insTypeIcon[57] = 'care_line'
insTypeIcon[58] = 'advancemoney'
insTypeIcon[151] = 'bingdu_huaban1'
export const insTypeName = [
  '身价保障',
  '固定领取',
  '疾病保障',
  '浮动分红',
  '医疗保障',
  '保费豁免',
  '万能账户',
  '伤残保障',
  '其他保障'
  // '寿险保障', '护理保障', '财产保障' // 52, 58, 59
]
insTypeName[51] = '寿险保障'
insTypeName[57] = '护理保障'
insTypeName[58] = '财产保障'
insTypeName[151] = '新冠肺炎'
export const insTypeOrders = {
  normal: [152, 2, 4, 7, 8, 1, 52, 3, 5, 58, 6, 59, 9],
  healthy: [152, 3, 5, 58, 2, 4, 7, 6, 8, 1, 52, 59, 9],
  accident: [152, 8, 1, 52, 3, 5, 58, 2, 4, 7, 6, 59, 9],
  kmh: [152, 2, 4, 7, 8, 1, 52, 3, 5, 58, 6, 59, 9]
}
export const instypeSummary = {
  1: '生命无价，不同产品的身价保障可叠加赔付',
  3: '健康无价，不同产品重疾保障可叠加赔付',
  6: '交费期内出险，免交后期保费，保单继续有效',
  8: '健康无价，不同产品的伤残保障可叠加赔付'
}
// 渲染预处理
export const preHandleKeys = [
  {
    key: 'waitingDuration',
    value: '疾病等待期：{value}'
  }
]
// 渲染字段
export const showKeys = [
  'headline',
  'description1',
  'description2',
  // 'liabilityImg',
  // 'waitingDuration',
  'comment',
  'extraDesc'
]
export const accShowKeys = [
  'description1',
  'guaranteeLimit',
  'description2',
  'comment'
]
// 对比渲染字段
export const diffShowKeys = ['description1']
export const contrastShowKeys = ['description1', 'description2', 'comment']
// 隐藏字段
export const hideKey = 'comment'
// 醒目字段
export const washKeys = [
  'baoeDesc',
  // 'baofDesc',
  'iDurationDesc',
  'pPeriodDesc'
]
// 取值字段
export const normalizeKeys = [
  'iDuration.duration',
  'pPeriod.period',
  'rMode.mode',
  'rAge.rage',
  'smoke.smk',
  'social.soc',
  'isNewInsure.newinsure',
  'totalBaof.totalbaof'
]
// 表头字段
export const tableHead = ['投保险种', '保额', '保险期/交费期', '首年保费']
// 追加领取标题
export const addAndTakeHead = [
  '灵活追加，复利计息稳健增值',
  '灵活领取，满足人生各阶段保障需求'
]
// 条款按钮
export const termsBtnText = '条款详情'
// 分享描述
export const SHARE_DECS =
  '为您设计的专属保险计划书，请查阅！保险——让生活更美好！'
export const POLICY_SHARE_DECS =
  '为您整理的保单，请查阅，保险——让生活更美好！'
// 条款地址
export const baseTermUrl = PLANBOOK_PAGE_MAP.terms
export const SHARE_TIL = '产品计划书演示'
export const POLICY_WECHAT_SHARED_LOGO = 'https://img.winbaoxian.com/static/images/planBook/insurecomp/company/v5/20180925161307277.jpg@!planbookLogo'
export const appVersion = Jax.getAppVersion()
export const bApp = Jax.isApp()
export const isBxs = Jax.isBxsApp()
export const isBroker = Jax.isBrokerApp()
export const isToBApp = Jax.isYjjApp() || Jax.isToBApp()
export const isYjjApp = Jax.isYjjApp()
export const isTrueToBApp = Jax.isToBApp()
export const isNuoYa = Jax.isRongYiBaoApp()
export const isBaoXiaoZhu = Jax.isBaoXiaoZhuApp()
// c 端可以用，a 端不保证已获取，需要从cookie中获取
const TOB_APPID = getUrlParam('app')
const isToBClient =
  TOB_APPID !== '' && TOB_APPID !== 'Broker' && TOB_APPID !== 'Bxs'
export const isToB = isToBApp || isToBClient
export const inWechat = Jax.isWeChat()

export const isWeEnterprise = window.WeCom && WeCom.isWeEnterprise && WeCom.isWeEnterprise()
export const isWeCom = window.WeCom && WeCom.isWeCom && WeCom.isWeCom()
export const isMiniBankInsurance = window.WeCom && WeCom.isMiniBankInsurance && WeCom.isMiniBankInsurance()

// 授权类型
export const WX_CS_TYPE = {
  QUESTIONNAIRE: 1,
  BUSINESSCARD: 2,
  ACTIVITY: 3,
  PLANBOOK: 4,
  FAMILYPOLICY: 6,
  MULTIPLANBOOK: 14,
  ANNUALREPORT: 19,
  CONTRAST: 23
}
export const SHOW_TYPE = {
  responsibility: 0,
  insurance: 1
}
export const DISEASE_BASE = {
  serious: { name: '重疾病种', id: '#e3', index: 1 },
  disease: { name: '中症病种', id: '#e4', index: 2 },
  mild: { name: '轻症病种', id: '#e5', index: 3 }
}
export const COVER_TYPE = {
  cover_t2: '//img.winbaoxian.com/static/images/n3/pbf/cover_com.png',
  cover_t3: '//img.winbaoxian.com/autoUpload/planbook/__8a2b3f516b3765d.png',
  cover_t4: '//img.winbaoxian.com/static/images/n3/pbf/cover_yw.png',
  cover_t5: '//img.winbaoxian.com/static/images/n3/pbf/cover_lc.png',
  cover_t6: '//img.winbaoxian.com/static/images/n3/pbf/cover_jk.png',
  cover_t7: '//img.winbaoxian.com/static/images/n3/pbf/cover_lc2.png',
  cover_t8: '//img.winbaoxian.com/static/images/n3/pbf/cover_com2.png',
  cover_t9: '//img.winbaoxian.com/static/images/n3/pbf/cover_com3.png',
  cover_t10: '//img.winbaoxian.com/autoUpload/planbook/__a3c9aba3783c386.png',
  cover_t11: '//img.winbaoxian.com/autoUpload/planbook/-2-_afefe09bfb24eda.jpg'
}
export const APPID = (() => {
  let appId = getAppId()
  if (!appId && !IS_APP_PLATFORM) {
    const app = getUrlParam('app')
    switch (app) {
      case 'Broker':
        appId = BROKER_APPID
        break
      case '':
      case 'Bxs':
        appId = BXS_APPID
        break
      default:
        appId = app
        break
    }
  }
  return appId
})()

export const wxMpAppid = getUrlParam('wxMpAppid') || WX_AUTH_PUBLIC_APPID
export const componentAppid = getUrlParam('component_appid')
